import { line } from 'd3-shape'
import first from 'lodash/first'
import last from 'lodash/last'
import { REGION_BAR_GRAPH_LINESTROKE } from './libs/colors'

export const RegionLineLayerForBarGraph = (barEntries: number) => {
  const lineLayer = ({
    bars,
    xScale,
    yScale,
  }: {
    bars: any
    xScale: any
    yScale: any
  }) => {
    const MieteLinegenerator: any = line()
      .x((d: any) => {
        return xScale(d.data.indexValue) + d.width / 2
      })
      .y((d: any) => yScale(d.data.data.lineValueMiete))

    const KaufLineGenerator: any = line()
      .x((d: any) => {
        return xScale(d.data.indexValue) + d.width + d.width / 2
      })
      .y((d: any) => yScale(d.data.data.lineValueKauf))

    const newBars = bars.slice(0, barEntries)
    const first_last_Bar: [number, number] = [
      first(newBars) as number,
      last(newBars) as number,
    ]

    return (
      <>
        <path
          d={MieteLinegenerator(first_last_Bar)}
          fill="none"
          strokeWidth="4"
          stroke={REGION_BAR_GRAPH_LINESTROKE[0]}
        />

        <path
          d={KaufLineGenerator(first_last_Bar)}
          fill="none"
          strokeWidth="4"
          stroke={REGION_BAR_GRAPH_LINESTROKE[1]}
        />
      </>
    )
  }

  return { lineLayer }
}
